import React from 'react';
import Util from 'service/util';
import moment from 'moment';

function getWeekdays(arr)
{
  return arr.filter(x => x).map(x => {
    switch (x) {
      case 1: return "一";
      case 2: return "二";
      case 3: return "三";
      case 4: return "四";
      case 5: return "五";
      case 6: return "六";
      case 7: return "日";
    }
  }).join(' ');
}

function formatBaseSalary(sal)
{
  if (('undefined' === typeof sal) || null == sal) return '按車場';
  return '$'+Util.nf(sal);
}

class SalaryTable extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = { adjust: 0 };
  }

  render()
  {
    const data = this.props.data;
    if (!data || !Object.keys(data.salary).length) return <p className="message red">無記錄。</p>;

    let [T_mpf
      ,T0,T1,T2,T3
      ,C0,C1,C2,C3
      ,D0,D1,D2,D3
    ] = Object.values(data.salary).reduce((r,x) => {
    //r[ 0] += x.mpf;
      r[ 1] += x.salary_1 + x.salary_2 + x.salary_3;
      r[ 2] += x.salary_1;
      r[ 3] += x.salary_2;
      r[ 4] += x.salary_3;
      r[ 5] += x.count_1 + x.count_2 + x.count_3;
      r[ 6] += x.count_1;
      r[ 7] += x.count_2;
      r[ 8] += x.count_3;
      r[ 9] += x.leave_deduct_1 + x.leave_deduct_2 + x.leave_deduct_3;
      r[10] += x.leave_deduct_1;
      r[11] += x.leave_deduct_2;
      r[12] += x.leave_deduct_3;
      return r;
    }, new Float32Array(13));

    let items = Object.values(data.salary);
    items.sort((a,b) => {
      if (a.srv_dis > b.srv_dis) return  1;
      if (a.srv_dis < b.srv_dis) return -1;
      if (a.srv_loc > b.srv_loc) return  1;
      if (a.srv_loc < b.srv_loc) return -1;
      return 0;
    });

    return (
      <>
        <div className="box">
          <h4 className="box-head">員工資料</h4>
          <div className="box-body">
            <label className="field">
              <strong>員工名稱</strong>
              <span>{ data.worker.display_name }</span>
            </label>
            <div className="split-3">
              <label className="field">
                <strong>員工編號</strong>
                  <span>#{ data.worker.id }</span>
              </label>
              <label className="field">
                <strong>系統名稱</strong>
                <span>{ data.worker.login_name }</span>
              </label>
            </div>
            <div className="salary-detail">
              <label className="field">
                <strong>基本薪金</strong>
                <span>A: {formatBaseSalary(data.worker.salary_A)} | B: {formatBaseSalary(data.worker.salary_B)} | C: {formatBaseSalary(data.worker.salary_C)}</span>
              </label>
              <label className="field">
                <strong>獎金每輛</strong>
                <span>A: ${Util.nf(data.worker.bonus_A)} | B: ${Util.nf(data.worker.bonus_B)} | C: ${Util.nf(data.worker.bonus_C)}</span>
                </label>
              <label className="field">
                <strong>打蠟每輛</strong>
                <span>${Util.nf(data.worker.sal_wax)}</span>
                </label>
              <label className="field">
                <strong>輪抹每輛</strong>
                <span>${Util.nf(data.worker.sal_rot)}</span>
              </label>
            </div>
            { !data.leave?'':
              <label className="field">
                <strong>請假</strong>
                <div>
                { data.leave.map(l =>
                  <span className="leave-tag">
                    <span className="type">{ Util.getLeaveType(l.leave_type) }</span>
                    <span className="date">{ Util.ShortDate(l.leave_dtm) }</span>
                    <span className="pay-ratio">{ (l.pay_ratio*100).toFixed(0) }%</span>
                  </span>
                )}
                </div>
              </label>
            }
          </div>
        </div>
        <table className="salary-amount">
          <thead>
            <tr>
              <th>車場</th>
              <th className="right">總薪金</th>
              <th className="right">A車</th>
              <th className="right">A車 ($)</th>
              <th className="right">B車</th>
              <th className="right">B車 ($)</th>
              <th className="right">C車</th>
              <th className="right">C車 ($)</th>
              {/* <th className="right">MPF</th> */}
            </tr>
          </thead>
          <tbody>
            { items.map(d =>
              <tr key={`${this.props.staff}-${d.srv_dis}${d.srv_loc}`}>
                <th>{d.srv_dis}{d.srv_loc} - {d.loc_name}</th>
                <td className="right">{ !!d.salary_total && '$'+Util.nf2(d.salary_total) }</td>
                <td className="right">{ !!d.count_1      &&     Util.nf (d.count_1     ) }</td>
                <td className="right">{ !!d.salary_1     && '$'+Util.nf2(d.salary_1    ) }</td>
                <td className="right">{ !!d.count_2      &&     Util.nf (d.count_2     ) }</td>
                <td className="right">{ !!d.salary_2     && '$'+Util.nf2(d.salary_2    ) }</td>
                <td className="right">{ !!d.count_3      &&     Util.nf (d.count_3     ) }</td>
                <td className="right">{ !!d.salary_3     && '$'+Util.nf2(d.salary_3    ) }</td>
                {/* <td className="right">${ Util.nf2(d.mpf) }</td> */}
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <th>加總</th>
              <td className="right">{ !!T0 && '$'+Util.nf2(T0) }</td>
              <td className="right">{ !!C1 &&     Util.nf (C1) }</td>
              <td className="right">{ !!T1 && '$'+Util.nf2(T1) }</td>
              <td className="right">{ !!C2 &&     Util.nf (C2) }</td>
              <td className="right">{ !!T2 && '$'+Util.nf2(T2) }</td>
              <td className="right">{ !!C3 &&     Util.nf (C3) }</td>
              <td className="right">{ !!T3 && '$'+Util.nf2(T3) }</td>
              {/* <td className="right">${ Util.nf2(T_mpf) }</td> */}
            </tr>
            { D0 > 0 && <>
              <tr className="leave-deduct">
                <th>假期扣減</th>
                <td className="right">{ !!D0 && '-$'+Util.nf2(D0) }</td>
                <td className="right"></td>
                <td className="right">{ !!D1 && '-$'+Util.nf2(D1) }</td>
                <td className="right"></td>
                <td className="right">{ !!D2 && '-$'+Util.nf2(D2) }</td>
                <td className="right"></td>
                <td className="right">{ !!D3 && '-$'+Util.nf2(D3) }</td>
                {/*<td className="right"></td>*/}
              </tr>
              <tr>
                <th>小計</th>
                <td className="right">{ !!(T0-D0) && '$'+Util.nf2(T0-D0) }</td>
                <td className="right"></td>
                <td className="right">{ !!(T1-D1) && '$'+Util.nf2(T1-D1) }</td>
                <td className="right"></td>
                <td className="right">{ !!(T2-D2) && '$'+Util.nf2(T2-D2) }</td>
                <td className="right"></td>
                <td className="right">{ !!(T3-D3) && '$'+Util.nf2(T3-D3) }</td>
                {/* <td className="right">${ Util.nf2(T_mpf) }</td> */}
              </tr>
              </>
            }
            <tr>
              <th>津貼</th>
              <td className="right">${ Util.nf2(data.worker.allowance) }</td>
              <td colSpan="6"></td>
            </tr>
            { data.bonus != null && <>
              { (data.bonus.bouns != 0) &&
                <tr>
                  <th>本月獎金</th>
                  <td className="right">${ Util.nf2(data.bonus.bonus) }</td>
                  <td colSpan="6">
                    { data.bonus?.add?.map((x,i) =>
                      <div key={i}><span className={`p ${x.p}`}>{x.p}</span>{ x.l }</div>
                    )}
                  </td>
                </tr>
              }
              { (data.bonus.deduct != 0) &&
                <tr>
                  <th>獎金扣除</th>
                  <td className="right">
                    <span className="bonus-deduct">${ Util.nf2(data.bonus.deduct) }</span>
                  </td>
                  <td colSpan="6">
                    { data.bonus.sub?.map((x,i) =>
                      <div key={i}><span className={`p ${x.p}`}>{x.p}</span>{ x.l }</div>
                    )}
                  </td>
                </tr>
              }
              { data.bonus.wax_cnt > 0 &&
                <tr>
                  <th>打蠟車數量</th>
                  <td className="right">
                    <span>({ Util.nf(data.bonus.wax_cnt) }) </span>
                    <span>${ Util.nf2(data.bonus.wax_sal) } </span>
                  </td>
                  <td colSpan="6">
                    <div className="split-8 ls-wax-lic">
                      { data.bonus.wax.map((l,i) =>
                        <span key={i} className="tag license">{l}</span>
                      )}
                    </div>
                  </td>
                </tr>
              }
              { data.bonus.rot_cnt > 0 &&
                <tr>
                  <th>輪抹車數量</th>
                  <td className="right">
                    <span>({ Util.nf(data.bonus.rot_cnt) }) </span>
                    <span>${ Util.nf2(data.bonus.rot_sal) } </span>
                  </td>
                  <td colSpan="6">
                    <div className="split-4 ls-rot-lic">
                      { data.bonus.rot.map((l,i) =>
                        <span key={i} className="tag license">{l}</span>
                      )}
                    </div>
                  </td>
                </tr>
              }
            </>}
            <tr>
              <th>調整</th>
              <td className="adj-cell"><input className="adj-txt right" step="0.01" type="number" placeholder="$"
                value={this.state.adjust} onChange={e=>this.setState({adjust: parseFloat(e.target.value)}) } /></td>
              <td colSpan="6"></td>
            </tr>
            <tr>
              <th>總計</th>
              <td className="right">${ Util.nf2(
                T0 + data.worker.allowance
                   + (data.bonus?.total   ??0 )
                   + (data.bonus?.rot_sal ??0 )
                   + (data.bonus?.wax_sal ??0 )
                   + this.state.adjust
                   - D0
              ) }</td>
              <td colSpan="6"></td>
            </tr>
          </tfoot>
        </table>
        <table className="salary-detail">
          <colgroup>
            <col width="60px"  id="col-salary-loc" />
            <col width="120px" id="col-salary-license" />
            <col width="300px" id="col-salary-psn" />
            <col width="60px"  id="col-salary-plan" />
            <col width="120px" id="col-salary-weekday" />
            <col width="60px"  id="col-salary-waxing" />
            <col width="auto"  id="col-salary-remarks" />
            <col width="260px" id="col-salary-date" />
          </colgroup>
          <thead>
            <tr>
              <th>車場</th>
              <th>車牌</th>
              <th>車位</th>
              <th>計劃</th>
              <th>星期</th>
              <th>打蠟</th>
              <th>備註</th>
              <th>服務日期</th>
            </tr>
          </thead>
          <tbody>
            { this.renderDetailRows(items) }
          </tbody>
        </table>
      </>
    );
  } // render

  renderDetailRows(items)
  {
    let rows = [];

    items.forEach(a => {
      let h1 = Object.values(a.detail).map(x=>x.range.length).reduce((r,x)=>r+x,0);
      Object.keys(a.detail).sort().forEach((license,i) => {
        let b = a.detail[license];
        let h2 = b.range.length;
        b.range.sort((x1,x2) => {
          if (x1.s > x2.s) return  1;
          if (x1.s < x2.s) return -1;
          return 0;
        });
        b.range.forEach((r,j) => {
          rows.push({
             h1, h2
            ,loc: i==0&&j==0?`${a.srv_dis}${a.srv_loc}`:null
            ,license: j==0?license:null
            ,remarks: j==0?b.remarks:null
            ,plan: r.p
            ,range: `${Util.ShortDate(r.s)} - ${Util.ShortDate(r.e)} (${(1+moment(r.e).diff(moment(r.s), 'days' )).toFixed(0)}日)`
            ,psn: r.psn
            ,d1: r.d1
            ,d2: r.d2
            ,d3: r.d3
            ,waxing: r.wx
          });
        }); // level 3
      }); // level 2
    }); // level 1

    return rows.map((r, i) =>
      <tr key={i}>
        { !r.loc?'':<td rowSpan={r.h1}>{ r.loc }</td> }
        { !r.license?'':<td rowSpan={r.h2}>{ r.license }</td> }
        <td>{ r.psn }</td>
        <td>{ r.plan }</td>
        <td>{ getWeekdays([r.d1, r.d2, r.d3]) }</td>
        <td>{ r.waxing && '是' }</td>
        { !r.license?'':<td rowSpan={r.h2}>{ r.remarks }</td> }
        <td>{ r.range }</td>
      </tr>
    );
  } //render detail

}

export default SalaryTable;